module.exports = __webpack_public_path__ + "img/us.ae656592.svg";